var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g({ref:"imgRef",staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.url}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }